import React, { useState } from "react";
import { usePagination } from "src/hooks";
import { AdminTableContainer } from "../admin/admin-style";
import { ActionMenu, Table } from "../ui";
import EditOccupationModal from "./EditOccupation";
import { OccupationDetailsModal } from "./OccupationDetailsModal";
import { CiEdit } from "react-icons/ci";
import { IoTrashBin } from "react-icons/io5";
import { IoEyeOutline } from "react-icons/io5";
import { toast, ToastContainer } from "react-toastify";
import { logout } from "src/utils/AuthUtils";
import ModalContent from "../common/ModalContent";
import AppModal from "../ui/widget/Modal/Modal";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "src/store";
import { useDeleteOccupationMutation } from "src/store";
import { PaginationProps } from "../ui/Pagination";
import { useEffect } from "react";

type Props = {
  rows: any;
  fetchOccupation: Function;
  Ppage: number;
  setPage: React.Dispatch<React.SetStateAction<number>>;
  paginationData: PaginationProps;
};

const OccupationTable = ({
  rows,
  fetchOccupation,
  Ppage,
  setPage,
  paginationData,
}: Props) => {
  const dispatch = useAppDispatch();
  const [deleteOccupation] = useDeleteOccupationMutation();
  const [rowId, setRowId] = useState("");
  const [showModal, setShowModal] = useState<boolean | null>(false);
  const [allowRowClick, setAllowRowClick] = useState(true);
  const [occupationID, setOccupationID] = useState("");
  const [occupationDetails, setOccupationDetails] = useState({});
  const [open, setOpen] = useState(false);
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [selectedOccupationName, setSelectedOccupationName] = useState("");
  const handleOpen = () => setOpen(true);

  const handleClose = () => setOpen(false);

  const deleteOccupationHandler = async (id: string) => {
    try {
      const result = await deleteOccupation(id);
      if (result.data) {
        toast.success(result.data.message);
      }
    } catch (error) {
      console.error("Error deleting occupation:", error);
      toast.error("Failed to delete occupation");
    } finally {
      fetchOccupation();
    }
  };

  const TableHeaders = [
    {
      title: "Icon",
      render: (row: any) => (
        <img
          style={{
            width: "40px",
            height: 40,
            borderRadius: "50%",
            objectFit: "cover",
          }}
          src={row?.image || ""}
          alt=""
        />
      ),
    },
    { title: "Occupations", render: (row: any) => `${row?.name.trim() || ""}` },
    {
      title: "Category",
      render: (row: any) => `${row?.category_slug || ""}`,
    },
    // {
    //   title: "Base Fee",
    //   render: (row: any) => `${row?.base_fee || ""}`,
    // },
    {
      title: "Total vendors",
      render: (row: any) => `${row?.totalVendors || "0"}`,
    },
    {
      title: "Total Male",
      render: (row: any) => `${row?.male || "0"}`,
    },
    {
      title: "Total Female",
      render: (row: any) => `${row?.female || "0"}`,
    },

    {
      title: "",
      render: (row: any) => (
        <ActionMenu
          setAllowRowClick={(bool: boolean) => {
            setAllowRowClick(bool);
          }}
          actions={[
            {
              title: (
                <div className="w-full flex cursor-pointer items-center gap-4">
                  <IoEyeOutline size={15} />
                  <span>View Details</span>
                </div>
              ),
              onClick: () => {
                setSelectedOccupationName(row.name);
                setShowDetailsModal(true);
              },
            },
            {
              title: (
                <div className="w-full flex cursor-pointer items-center gap-4">
                  <CiEdit size={15} />
                  <span>Edit</span>
                </div>
              ),
              onClick: () => {
                setOccupationDetails(row);
                // console.log(row?.name);
                handleOpen();
                setOccupationID(row._id);
              },
            },
            {
              title: (
                <div className="w-full flex cursor-pointer items-center gap-4">
                  <IoTrashBin size={15} className="text-red-500" />
                  <span>Delete</span>
                </div>
              ),
              onClick: () => {
                // deleteOccupationHandler(row._id);
                setRowId(row._id);
                setShowModal(true);
              },
            },
          ]}
        />
      ),
    },
  ];
  const { page, limit, Pagination } = usePagination(
	{
	  page: Ppage,
	  limit: 10,
	  total: rows.length,
	  setPageNo: setPage,
	},
	paginationData,
  );
  const [paginatedRows, setPaginatedRows] = useState<[]>([]);
  useEffect(() => {
	// setPaginatedRows(rows.slice((page - 1) * limit, page * limit));
	setPaginatedRows(rows);
  }, [page, limit, rows]);

  return (
    <AdminTableContainer>
      <ToastContainer />
      <div className="heading">
        <p className="count">{paginationData.total} Occupations</p>
      </div>
      <EditOccupationModal
        id={occupationID}
        data={occupationDetails}
        open={open}
        fetchOccupation={fetchOccupation}
        handleClose={handleClose}
      />
      {showDetailsModal && (
        <OccupationDetailsModal
          occupationName={selectedOccupationName}
          onClose={() => setShowDetailsModal(false)}
        />
      )}
      {paginatedRows.length > 0 ? (
        <Table rows={paginatedRows} headers={TableHeaders} showHead={true} />
      ) : (
        <div className="flex justify-center py-4">
          {" "}
          No Available Occupation{" "}
        </div>
      )}

      <Pagination />
      <AppModal
        open={showModal}
        onClose={() => setShowModal(false)}
        content={
          <ModalContent
            // content1={rowId}
            content2="Are you sure you want to delete this occupation?"
            btnAction={() => {
              deleteOccupationHandler(rowId);
            }}
            linkContent="Delete"
            onClick={() => setShowModal(false)}
          />
        }
      />
    </AdminTableContainer>
  );
};
export default OccupationTable;
